/* eslint-disable */
export const validationRules = {
    requiredField: [
        (val) => (val && val.length > 0) || 'El campo es requerido',
    ],
    requiredSelectField: [
        (val) => !!val || 'Este campo es obligatorio'
    ],
    requiredEmail: [
        (val) => (val && val.length > 0) || 'El campo es requerido',
        (val) => (val && val.length >= 3) || 'El campo debe tener al menos 3 caracteres',
        (val) => (val && validateEmail(val) || 'El campo debe ser un correo electrónico válido')
    ],
    timeField: [
        (val) => (val && val.length > 0) || 'El campo es requerido',
        (val) => (val && validateTimeFormat(val)) || 'El campo este mal escrito. El tiempo máximo es 23:59:59'
    ],
    name: [
        (val) => (val && val.length > 0) || 'El campo es requerido',
        (val) => (val && val.length >= 3) || 'El campo debe tener al menos 3 caracteres',
        (val) => (val && validateTextNumber(val) || 'El campo no puede recibir caracteres especiales')
    ],
    shortName: [
        (val) => (val && val.length >= 2) || 'El campo debe tener al menos 2 caracteres',
    ],
    generalName: [
        (val) => (val && val.length > 0) || 'El campo es requerido',
        (val) => (val && val.length >= 3) || 'El campo debe tener al menos 3 caracteres',
    ],
    text: [
        (val) => (val && val.length > 0) || 'El campo es requerido',
        (val) => (val && val.length >= 3) || 'El campo debe tener al menos 3 caracteres',
        (val) => (val && validateText(val) || 'El campo no puede recibir acentos, espacios ni caracteres especiales')
    ],
    address: [
        (val) => (val && val.length > 0) || 'El campo es requerido',
        (val) => (val && val.length >= 3) || 'El campo debe tener al menos 3 caracteres',
        (val) => (val && validateAddressText(val) || 'El campo no puede recibir caracteres especiales a excepción de espacios, acentos, ñ|Ñ, . y - #')
    ],
    latitude: [
        (val) => (val && validateLatitudeText(val) || 'El campo no puede recibir letras ni caracteres especiales')
    ],
    longitude: [
        (val) => (val && validateLongitudeText(val) || 'El campo no puede recibir letras ni caracteres especiales')
    ],
    nameVehicle: [
        (val) => (val && val.length > 0) || 'El campo es requerido',
        (val) => (val && val.length >= 1) || 'El campo debe tener al menos 3 caracteres',
        (val) => (val && validateTextNumber(val) || 'El campo no puede recibir caracteres especiales')
    ],
    numberDecimal: [
        (val) => (val && (val).toString().length > 0) || 'El campo es requerido',
        (val) => (val && (val).toString().length >= 1) || 'El campo debe tener al menos 1 caracter'
    ],
    numberVehicle: [
        (val) => (val && val.length > 0) || 'El campo es requerido',
        (val) => (val && val.length < 6) || 'El campo debe tener menos de 5 caracteres',
        (val) => (val && validateTextNumberWithoutSpace(val) || 'El campo no puede recibir espacios ni caracteres especiales')
    ],
    numberPlate: [
        (val) => (val && val.length > 0) || 'El campo es requerido',
        (val) => (val && val.length < 8) || 'El campo debe tener menos de 7 caracteres',
        (val) => (val && validateTextNumberWithoutSpace(val) || 'El campo no puede recibir espacios ni caracteres especiales')
    ],
    number: [
        (val) => (val && (val).toString().length > 0) || 'El campo es requerido',
        (val) => (val && (val).toString().length >= 1) || 'El campo debe tener al menos 1 caracteres',
        (val) => (val && validateNumber(val) || 'El campo no puede recibir espacios ni caracteres especiales')
    ],
    nameDevice: [
        (val) => (val && val.length > 0) || 'El campo es requerido',
        (val) => (val && val.length >= 1) || 'El campo debe tener al menos 3 caracteres',
        (val) => (val && val.length < 21) || 'El campo debe tener menos de 20 caracteres',
        (val) => (val && validateTextNumber(val) || 'El campo no puede recibir caracteres especiales')
    ],
    nameFirmware: [
        (val) => (!val || (val &&  val.length < 21)) || 'El nombre debe tener máximo 20 caracteres',
        (val) => (!val || (val && validateTextNumberPointWithoutSpace(val))  || 'El nombre solo puede tener punto, números y letras')
    ],
    nameIdentification: [
        (val) => (val && val.length > 0) || 'El campo es requerido',
        (val) => (val && val.length < 21) || 'El campo debe tener menos de 20 caracteres',
        (val) => (val && validateTextNumberPointWithoutSpace(val) || 'El campo no puede recibir espacios ni caracteres especiales')
    ]
}

export const validatePercent = (value: string) => {
    if (value === '') return 'El campo es requerido';
    const num = parseFloat(value);
    return num >= 0 && num <= 100 ? true : 'El valor debe ser entre 0 y 100';
};

const validateTextNumber = (val: string) => {
    const result = new RegExp("^[a-zA-Z0-9áéíóúñÁÉÍÓÚÑ\\s]*$").test(val);
    return (result) ? true : false;
}

const validateEmail = (val: string) => {
    const result = /@.*\./.test(val);
    return result;
  };

export const validateText = (val: string) => {
    const result = new RegExp("^[a-zA-Z0-9]*$").test(val);
    return (result) ? true : false;
}

const validateAddressText = (val: string) => {
    const result = new RegExp("^[a-zA-Z0-9áéíóúñÁÉÍÓÚÑ.,\\-#\\s]*$").test(val);
    return (result) ? true : false;
}

const validateLatitudeText = (val: string) => {
    const result = new RegExp("^(\\+|-)?(?:90(?:(?:\\.0{1,6})?)|(?:[0-9]|[1-8][0-9])(?:(?:\\.[0-9]{1,25})?))$").test(val);
    return (result) ? true : false;
}

const validateLongitudeText = (val: string) => {
    const result = new RegExp("^(\\+|-)?(?:180(?:(?:\\.0{1,6})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\\.[0-9]{1,25})?))$").test(val);
    return (result) ? true : false;
}

const validateTextNumberWithoutSpace = (val: string) => {
    const result = new RegExp("^[a-zA-Z0-9]*$").test(val);
    return (result) ? true : false;
}

const validateNumber = (val: string) => {
    const result = new RegExp("^[0-9]*$").test(val);
    return (result) ? true : false;
}

export const validateTextNumberPointWithoutSpace = (val: string) => {
    const result = new RegExp("^[a-zA-Z0-9.]*$").test(val);
    return (result) ? true : false;
}

export const validateTimeFormat = (time: string) => {
    const timeRegex = /^(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/;
    const result = !timeRegex.test(time);
    return (result) ? false : true;
};